import api from "./axios";
import type { ScraperHistory } from "@/types";

export const getAll = (scraperId?: string, limit?: number, offset?: number) =>
  api
    .get<{ items: ScraperHistory[]; total: number }>("/history", {
      params: { scraperId, limit, offset },
    })
    .then((r) => r.data);

export const getRecent = (limit?: number) =>
  api
    .get<ScraperHistory[]>("/history/recent", { params: { limit } })
    .then((r) => r.data);

export const clearHistory = (scraperId?: string) =>
  api
    .delete("/history", { params: scraperId ? { scraperId } : {} })
    .then((r) => r.data);
